import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
export const SimpleTooltip = ({text, cy, children}) => (
	<StyledSpan title={text} data-cy={cy}>
		{children}
	</StyledSpan>
);

const StyledSpan = Styled.span`
	display: flex;
`;

SimpleTooltip.propTypes = {
	text: PropTypes.string,
	cy: PropTypes.string,
	children: PropTypes.any.isRequired,
};
